/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiError,
  CreatePatientRequest,
  PatientLightResponse,
  SearchPatientResponse,
} from '../models/index';
import {
    ApiErrorFromJSON,
    ApiErrorToJSON,
    CreatePatientRequestFromJSON,
    CreatePatientRequestToJSON,
    PatientLightResponseFromJSON,
    PatientLightResponseToJSON,
    SearchPatientResponseFromJSON,
    SearchPatientResponseToJSON,
} from '../models/index';

export interface CreatePatientOperationRequest {
    instituteId: string;
    createPatientRequest: CreatePatientRequest;
}

export interface FindPatientByInstituteRequest {
    instituteId: string;
}

/**
 * 
 */
export class PatientApi extends runtime.BaseAPI {

    /**
     * Create a patient in an institute
     */
    async createPatientRaw(requestParameters: CreatePatientOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchPatientResponse>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling createPatient().'
            );
        }

        if (requestParameters['createPatientRequest'] == null) {
            throw new runtime.RequiredError(
                'createPatientRequest',
                'Required parameter "createPatientRequest" was null or undefined when calling createPatient().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/institutes/{institute_id}/patients`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreatePatientRequestToJSON(requestParameters['createPatientRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchPatientResponseFromJSON(jsonValue));
    }

    /**
     * Create a patient in an institute
     */
    async createPatient(requestParameters: CreatePatientOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchPatientResponse> {
        const response = await this.createPatientRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all patient by institute
     */
    async findPatientByInstituteRaw(requestParameters: FindPatientByInstituteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PatientLightResponse>>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling findPatientByInstitute().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/institutes/{institute_id}/patients`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PatientLightResponseFromJSON));
    }

    /**
     * Get all patient by institute
     */
    async findPatientByInstitute(requestParameters: FindPatientByInstituteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PatientLightResponse>> {
        const response = await this.findPatientByInstituteRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
